
export default {
  state: {
    error_timeslot_status: false,
    error_service_status: false,
    error_workspace_status: false,
    error_booking_status: false,
  },
  getters: {
    getErrorTimeslotStatus(state) {
      return state.error_timeslot_status
    },
    getErrorServiceStatus(state) {
      return state.error_service_status
    },
    getErrorWorkspaceStatus(state) {
      return state.error_workspace_status
    },
    getErrorBookingStatus(state) {
      return state.error_booking_status
    },
  },
  mutations: {
    UPDATE_ERROR_TIMESLOT_STATUS(state, data) {
      state.error_timeslot_status = data
    },
    UPDATE_ERROR_SERVICE_STATUS(state, data) {
      state.error_service_status = data
    },
    UPDATE_ERROR_WORKSPACE_STATUS(state, data) {
      state.error_workspace_status = data
    },
    UPDATE_ERROR_BOOKING_STATUS(state, data) {
      state.error_booking_status = data
    },
  },
  actions: {
  },
}
